import type {
	CommandSection,
	CommandSections,
	OrderedFilteredCommands,
	ListedCommand,
	CommandInternal,
} from '../../types/commands/index.tsx';

export const getGroupedCommands = (
	commands: CommandInternal[],
	sections: CommandSections | undefined,
) =>
	commands.reduce<OrderedFilteredCommands>(
		(acc, command) => {
			const listedCommand: ListedCommand = {
				command,
			};

			const createGroup = (id: string, section: CommandSection) => {
				if (!acc.grouped.some((group) => group.id === id)) {
					acc.grouped.push({
						...(section.renderName ? { renderGroup: section.renderName } : { group: section.name }),
						id,
						priority: section.priority,
						commands: [],
					});
				}
			};

			/**
			 * Add command to the group
			 */
			const addCommandGroup = (name: string, newCommand: ListedCommand) => {
				acc.grouped.find((group) => group.id === name)?.commands.push(newCommand);
			};

			const section = !!command.section && sections?.[command.section];

			if (section) {
				// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
				const id = command.section as string;

				createGroup?.(id, section);

				addCommandGroup(id, listedCommand);
			} else {
				acc.ungrouped.push(listedCommand);
			}

			acc.length += 1;

			return acc;
		},
		{ grouped: [], ungrouped: [], length: 0 },
	);
